/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ReactMarkdown from 'react-markdown';
import {
    shape, string, object, func,
} from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import { setUserConfirmationForSubscriptionPopup } from '../../../../../state/ducks/App/App-Actions';

const styles = (theme) => ({
    dialogContent: {
        fontSize: '.8em',
    },
    subscriptionMessage: {
        fontSize: '.9em',
        padding: '2em 0',
        margin: '1em 0',
        '& span': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    subscriptionDetailsContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '10px',
        '@media screen and (max-width: 768px)': {
            textAlign: 'center',
        },
    },
    subscriptionDetails: {
        display: 'block',
        fontSize: 14,
        width: 399,
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
        margin: '0 auto',
        '& ul': {
            marginBottom: 0,
            lineHeight: '20px',
            marginTop: 20,
            paddingLeft: 10,
            [theme.breakpoints.down('xs')]: {
                paddingLeft: 40,
                marginTop: 10,
            },

        },
        '& span': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    dialogHeading: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flex: '0 0 auto',
        '@media screen and (max-width: 600px)': {
            '& >div': {
                width: '80%',
            },
            '& h2': {
                fontSize: '17px',
            },
        },
    },
    closeButton: {
        padding: '16px 24px',
        '@media screen and (max-width: 600px)': {
            padding: '0 0 0 2px',
        },
    },
    closeBtn: {
        position: 'absolute',
        top: '0',
        right: '0',
    },
    popUpHeading: {
        textAlign: 'center',
        '& span': {
            fontSize: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '18px',
            },
        },
    },
    bottomContent: {
        margin: '0 auto',
        padding: '20px 0',
        fontSize: '20px',
        fontWeight: '600',
        color: theme.palette.black || '#000',
        textTransform: 'uppercase',
        textDecoration: 'underline',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
});

class TermsConditionModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    render() {
        const { open } = this.state;
        const {
            data, classes, handleUserConfirmation, trackEvent,
        } = this.props;

        const handleModal = (e, windowOpen) => {
            e.nativeEvent.stopImmediatePropagation();
            e.preventDefault();
            e.persist();
            e.stopPropagation();
            this.setState({ open: windowOpen });
        };

        const userConfirmation = () => {
            handleUserConfirmation(true);
            this.setState({ open: false });
        };

        const openModal = (e) => {
            handleModal(e, true);
            trackEvent('Subscriptions Experience', 'click – Step 4', 'Terms and Conditions viewed');
        };

        return (

            <>
                <Grid container className={classes.subscriptionDetailsContainer} data-testid="subscription-details">
                    <Grid item xs={12} sm={12}>
                        <Typography className={classes.subscriptionDetails}>
                            <div>Click <span key={1} data-testid="terms-and-condition" role="link" tabIndex={0} onClick={(e) => openModal(e)} onKeyDown={(event) => { if (event.keycode === 13); }}><u>here</u></span> for complete terms</div>
                        </Typography>
                    </Grid>
                </Grid>
                { open ? (
                    <Dialog data-testid="subscription-terms-condition-modal" open={open}>
                        <DialogTitle className={classes.popUpHeading} id="customized-dialog-title">
                            <span>Subscription Program Terms and Conditions</span>
                            <IconButton className={classes.closeBtn} aria-label="Close" onClick={(e) => { handleModal(e, false); }}>
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <MuiDialogContent className={classes.root}>
                            <Typography gutterBottom className={classes.dialogContent}>
                                <ReactMarkdown source={data.terms} escapeHtml="false" />
                            </Typography>
                        </MuiDialogContent>
                        <DialogActions>
                            <IconButton id="accept-subscription-button" aria-label="close" className={classes.bottomContent} onClick={userConfirmation}>
                                <span>Close</span>
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                ) : null }
            </>

        );
    }
}
TermsConditionModal.propTypes = {
    data: shape({
        terms: string.isRequired,
    }).isRequired,
    classes: object.isRequired,
    handleUserConfirmation: func.isRequired,
    trackEvent: func.isRequired,
};
const mapDispatchToProps = (dispatch) => ({
    handleUserConfirmation: bindActionCreators(setUserConfirmationForSubscriptionPopup, dispatch),
});

const styledTermsConditionModal = withStyles(styles)(TermsConditionModal);
export default connect(null, mapDispatchToProps)(styledTermsConditionModal);
